import { Link } from 'react-router-dom';
import { Card } from '../components/ui/Card';

export function NotFoundPage() {
  return (
    <div className="max-w-md mx-auto py-20">
      <Card>
        <h1 className="mb-2">404</h1>
        <p className="text-neutral-400 mb-4">This page doesn't exist.</p>
        <Link to="/" className="text-lime-400 hover:underline">
          Back home →
        </Link>
      </Card>
    </div>
  );
}
